import { useUploadDocumentMutation } from 'src/services/IMVCheckList';
import {
  useCreateImvReportDataMutation,
  useGetAllImvReportDataMutation,
  usePublishImvReportDataMutation,
  useSendForReviewMutation,
  useUpdateImvReportDataMutation,
  useUpdateSignDataMutation
} from 'src/services/IMVReport';

export const useIMVReportPage = () => {
  const [
    updateImvReportDataFn,
    {
      isLoading: updateImvReportIsLoading,
      isSuccess: updateImvReportSuccess,
      data: updateImvReportData,
      isError: updateImvReportIsError,
      error: updateImvReportError
    }
  ] = useUpdateImvReportDataMutation();

  const [
    updateSignDataFn,
    {
      isLoading: updateSignIsLoading,
      isSuccess: updateSignSuccess,
      data: updateSignData,
      isError: updateSignIsError,
      error: updateSignError
    }
  ] = useUpdateSignDataMutation();

  const [
    getAllImvReportData,
    {
      data: allImvReportData,
      error: allImvReportDataError,
      isError: allImvReportDataIsError,
      isLoading: allImvReportDataLoading,
      isSuccess: allImvReportDataIsSuccess
    }
  ] = useGetAllImvReportDataMutation();

  const [
    createImvReportDataFn,
    {
      isLoading: createImvReportLoading,
      isSuccess: createImvReportSuccess,
      data: createImvReportData,
      isError: createImvReportIsError,
      error: createImvReportError
    }
  ] = useCreateImvReportDataMutation();

  const [
    uploadDocument,
    {
      isLoading: uploadDocumentLoading,
      isSuccess: uploadDocumentSuccess,
      data: uploadDocumentData,
      isError: uploadDocumentIsError
    }
  ] = useUploadDocumentMutation();

  const [
    sendForReviewFunc,
    {
      isLoading: sendForReviewIsLoading,
      isSuccess: sendForReviewIsSuccess,
      data: sendForReviewData,
      isError: sendForReviewIsError,
      error: sendForReviewError
    }
  ] = useSendForReviewMutation();

  const [
    publishImvReportDataFn,
    {
      isLoading: publishImvReportLoading,
      isSuccess: publishImvReportSuccess,
      data: publishImvReportData,
      isError: publishImvReportIsError,
      error: publishImvReportError
    }
  ] = usePublishImvReportDataMutation();

  return {
    updateSignDataFn,
    updateSignIsLoading,
    updateSignData,
    updateSignSuccess,
    updateSignIsError,
    updateSignError,
    updateImvReportIsLoading,
    updateImvReportSuccess,
    updateImvReportData,
    updateImvReportDataFn,
    updateImvReportIsError,
    updateImvReportError,
    createImvReportLoading,
    createImvReportSuccess,
    createImvReportData,
    createImvReportDataFn,
    createImvReportIsError,
    createImvReportError,
    allImvReportData,
    allImvReportDataError,
    allImvReportDataIsError,
    allImvReportDataIsSuccess,
    allImvReportDataLoading,
    getAllImvReportData,
    uploadDocument,
    uploadDocumentLoading,
    uploadDocumentSuccess,
    uploadDocumentData,
    uploadDocumentIsError,
    sendForReviewFunc,
    sendForReviewData,
    sendForReviewError,
    sendForReviewIsLoading,
    sendForReviewIsError,
    sendForReviewIsSuccess,
    publishImvReportDataFn,
    publishImvReportLoading,
    publishImvReportSuccess,
    publishImvReportData,
    publishImvReportIsError,
    publishImvReportError
  };
};
